// Honey Comb NFT data
export const honeyCombNFTs = [
  {
    id: 'honey-comb-1',
    name: 'Honey Comb #1',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.15 ETH'
  },
  {
    id: 'honey-comb-2',
    name: 'Honey Comb #2',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.16 ETH'
  },
  {
    id: 'honey-comb-3',
    name: 'Honey Comb #3',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.15 ETH'
  },
  {
    id: 'honey-comb-4',
    name: 'Honey Comb #4',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.17 ETH'
  },
  {
    id: 'honey-comb-5',
    name: 'Honey Comb #5',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.15 ETH'
  },
  {
    id: 'honey-comb-6',
    name: 'Honey Comb #6',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.18 ETH'
  },
  {
    id: 'honey-comb-7',
    name: 'Honey Comb #7',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.15 ETH'
  },
  {
    id: 'honey-comb-8',
    name: 'Honey Comb #8',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.16 ETH'
  },
    
    {
    id: 'honey-comb-9',
    name: 'Honey Comb #9',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.19 ETH'
  },
    {
    id: 'honey-comb-10',
    name: 'Honey Comb #10',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.20 ETH'
  },
    {
    id: 'honey-comb-11',
    name: 'Honey Comb #11',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.21 ETH'
  },
       {
    id: 'honey-comb-12',
    name: 'Honey Comb #12',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.24 ETH'
  },
    
    {
    id: 'honey-comb-13',
    name: 'Honey Comb #13',
    image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4',
    price: '0.20 ETH'
  },
  { id: 'honey-comb-14', name: 'Honey Comb #14', image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4', price: '0.19 ETH' },
  { id: 'honey-comb-15', name: 'Honey Comb #15', image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4', price: '0.25 ETH' },
  { id: 'honey-comb-16', name: 'Honey Comb #16', image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4', price: '0.32 ETH' },
  { id: 'honey-comb-17', name: 'Honey Comb #17', image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4', price: '0.40 ETH' },
  { id: 'honey-comb-18', name: 'Honey Comb #18', image: 'https://img-cdn.magiceden.dev/vtk:1/da:t/rs:fill:400:0:0/plain/https%3A%2F%2Fimg.reservoir.tools%2Fimages%2Fv2%2Fmainnet%2Fi9YO%252F4yHXUdJsWcTqhqvfxovkgb24%252F%252FnvAepcmFJdig4gTBFN7j4b%252BAoPxHJRpYGCHOjOhsq%252Fh2T0OUk9RmvEqAb6nf765j2TDbjvxNl%252FB87iNkPAGnAnTdoGCVDyeQa.mp4', price: '0.22 ETH' }


    
    
    
    
    
    
];
